import { lazy } from 'react';

const cookieSendReceiptPage = lazy(
  () => import('@cookie/pages/order/[orderId]/transaction/send-receipt')
);

const cookieDirectReceiptPage = lazy(
  () => import('@cookie/pages/order/[orderId]/send-receipt')
);

const nextPayTransactionPage = lazy(
  () => import('@next_pay/pages/order/[orderId]/transaction/index')
);

export const Projects = {
  wave: {
    name: 'wave',
    receiptUpload: true,
    pages: {
      transaction: lazy(
        () => import('@wave/pages/order/[orderId]/transaction/index')
      ),
      sendReceipt: lazy(
        () => import('@wave/pages/order/[orderId]/transaction/send-receipt')
      ),
      directReceipt: lazy(
        () => import('@wave/pages/order/[orderId]/send-receipt')
      ),
    },
  },
  cookie: {
    name: 'cookie',
    receiptUpload: true,
    pages: {
      transaction: lazy(
        () => import('@cookie/pages/order/[orderId]/transaction/index')
      ),
      sendReceipt: cookieSendReceiptPage,
      directReceipt: cookieDirectReceiptPage,
    },
  },
  next_pay: {
    name: 'next_pay',
    receiptUpload: false,
    pages: {
      transaction: nextPayTransactionPage,
      sendReceipt: nextPayTransactionPage,
      directReceipt: nextPayTransactionPage,
    },
  },
  rio: {
    name: 'rio',
    receiptUpload: true,
    pages: {
      transaction: lazy(
        () => import('@rio/pages/order/[orderId]/transaction/index')
      ),
      sendReceipt: cookieSendReceiptPage,
      directReceipt: cookieDirectReceiptPage,
    },
  },
};

export const getCurrentProject = (projectIdEnv: ProjectId) => {
  const projectId = projectIdEnv ?? 'cookie';
  return Projects[projectId] || Projects.cookie;
};

export type ProjectId = keyof typeof Projects;
